import React, { FormEvent } from "react";

interface OnInput {
  (event: FormEvent<HTMLInputElement>): void;
}

export type LayoutProps = {
  layout: number;
  layoutClass?: string;
  logoUrl: string;
  hasLogo: boolean;
  backgroundUrl: string;
  initialCaption: string;
  businessName: string;
  logoInput: HTMLInputElement | null | undefined;
  onInput?: OnInput | undefined;
  invocate: Function;
  onClick?: Function;
  onToggleButton?: Function;
};

const layoutNames = ["", "Uno", "Dos", "Tres", "Cuatro", "Cinco", "Seis", "Siete", "Ocho", "Nueve"];

const LayoutPreview = ({
  layout,
  layoutClass,
  logoUrl,
  backgroundUrl,
  initialCaption,
  businessName,
  logoInput,
  onInput,
  invocate,
  onClick,
  onToggleButton,
  hasLogo,
}: LayoutProps) => (
  <div
    onClick={onClick ? () => onClick() : undefined}
    className={`outer-teaser main visible ${layoutClass || ""}`}
  >
    <div className="layout-name">{ layoutNames[layout] }</div>
    <div
      className={`imagiro ticker-items-tally-1 layout-${layout} ${hasLogo ? 'has-logo' : 'no-logo'}`}
      style={{ top: 0, transform: "none" }}
    >
      <div className="unit-outer">
        <div className="header">
          <div className="header-container">
            {hasLogo && <div className="logo" style={{ backgroundImage: `url(${logoUrl})` }} />}
            <button
              type="button"
              className="replace-logo"
              onClick={() => logoInput?.click()}
            >
              Replace logo
            </button>

            <button
              type='button'
              className='toggle-logo'
            >
              <span
                className={`mdi ${hasLogo ? "mdi-eye-off" : "mdi mdi-eye"}`}
                onClick={onToggleButton ? () => onToggleButton() : undefined}>
              </span>
            </button>


            <div className="name">
              <div className="name-interior">
                <p className="editable">
                  <span contentEditable suppressContentEditableWarning>
                    {businessName}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          className="background"
          style={{ backgroundImage: `url(${backgroundUrl})` }}
        />
        <div className="ticker">
          <div className="ticker-item ticker-item-1 editable" style={{ opacity: 1 }}>
            <span
              contentEditable
              suppressContentEditableWarning
              onInput={onInput}
              onBlur={(e) => invocate("caption", e.target.textContent)}
            >
              {initialCaption}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default LayoutPreview;
